/**
 * @generated SignedSource<<12eab614a910f9d3c27664ea5f163e3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReviewToolUseInput = {
  conversationId?: any | null | undefined;
  llmConversationId?: any | null | undefined;
  llmInteractionId?: any | null | undefined;
  status: string;
  toolUseId: string;
};
export type useReviewToolUseMutationReviewToolUseMutation$variables = {
  input: ReviewToolUseInput;
};
export type useReviewToolUseMutationReviewToolUseMutation$data = {
  readonly reviewToolUse: {
    readonly success: boolean;
  };
};
export type useReviewToolUseMutationReviewToolUseMutation = {
  response: useReviewToolUseMutationReviewToolUseMutation$data;
  variables: useReviewToolUseMutationReviewToolUseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReviewToolUsePayload",
    "kind": "LinkedField",
    "name": "reviewToolUse",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReviewToolUseMutationReviewToolUseMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReviewToolUseMutationReviewToolUseMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7a4bed5f982a42ac673d4a14d30203c5",
    "id": null,
    "metadata": {},
    "name": "useReviewToolUseMutationReviewToolUseMutation",
    "operationKind": "mutation",
    "text": "mutation useReviewToolUseMutationReviewToolUseMutation(\n  $input: ReviewToolUseInput!\n) {\n  reviewToolUse(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "89036e2cb6f79f1650a40696c8809dd6";

export default node;
